module.exports = __webpack_public_path__ + "static/media/TN-Men-DressShoes.acf92b2c.svg";